<template>
  <div class="container">

    <div class="user-center-warp">
<!--      <UserCenterLeftMenu :cur-title-index="0" ref="leftMenuChild"/>-->
      <div class="ucw-left">
        <div class="ucw-head">
          <img class="ucw-head-img" width="100" height="100" :src="this.proFileImgUrl" />
          <p class="ucw-user-name">{{ this.userNickName }}</p>
<!--          <img style="padding-bottom: 19px;" width="35" height="35" src="../../assets/vip-icon.png">-->
        </div>
        <router-link :to="{name:'userIndex'}" class="blk" :class="{'active':curTitleIndex === 9}">个人主页</router-link>
        <router-link :to="{name:'userCenter'}" class="blk" :class="{'active':curTitleIndex === 0}">我的信息</router-link>
        <router-link :to="{name:'orderInfo'}" class="blk" :class="{'active':curTitleIndex === 5}">我的订单</router-link>
        <router-link :to="{name:'myReport'}" class="blk" :class="{'active':curTitleIndex === 7}">我的报告</router-link>
        <router-link :to="{name:'userCoupon'}" class="blk" :class="{'active':curTitleIndex === 3}">我的优惠券</router-link>
        <router-link :to="{name:'myIntegral'}" class="blk" :class="{'active':curTitleIndex === 8}">我的积分</router-link>
        <router-link v-if="isMerchant" :to="{name:'userMerchant'}" class="blk" :class="{'active':curTitleIndex === 1}">律师/机构信息</router-link>
        <router-link v-if="isMember" :to="{name:'myVip'}" class="blk" :class="{'active':curTitleIndex === 2}">律师VIP</router-link>
      </div>

      <!--右边-->
      <transition name="list">
        <router-view/>
      </transition>
    </div>
<!--    <Footer :no-bg="false"/>-->
  </div>
</template>

<script>
  import { getUserProfile } from '@/api/userInfo/userInfo'
  export default {
    name: "UserCenterLeftMenu",
    data() {
      return {
        proFileImgUrl: '',
        userNickName: '佚名',
        curTitleIndex: 9,
        isMember: false,
        isMerchant: false
      }
    },
    created() {
      if(!this.proFileImgUrl) {
        this.getUserProfile();
      }
      if (localStorage.getItem('isMember') && localStorage.getItem("isMember") !== 'null'
        && localStorage.getItem("isMember") !== 'undefined') {
        if (localStorage.getItem("isMember") === 'false') {
          this.isMember = false;
        } else {
          this.isMember = true;
        }
      }
      if (localStorage.getItem('isSupplier') && localStorage.getItem("isSupplier") !== 'null'
        && localStorage.getItem("isSupplier") !== 'undefined') {
        if (localStorage.getItem("isSupplier") === 'false') {
          this.isMerchant = false;
        } else {
          this.isMerchant = true;
        }
      }
    },
    methods: {
      getUpdateUserProFile(url) {
        this.proFileImgUrl = url;
      },
      activeTitleIndex(indx){
        this.curTitleIndex = indx;
      },
      getUpdateUserNickName(name){
        this.userNickName = name;
      },
      getUserProfile(){
        getUserProfile().then((res)=>{
          if(res.data.code == 200){
            this.proFileImgUrl = res.data.data.cur;
            this.userNickName = res.data.data.nickName;
          }else{
            this.$message.error('获取头像文件出错');
          }
        });
      },
    }
  }
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #00BCA1;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>
<style scoped>

  .container {
    min-height: 880px;
  }

  .pdl20 {
    padding-left: 20px;
  }

  .user-center-warp {
    max-width: 1190px;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: flex-start;
  }

  /*left start*/
  .user-center-warp .ucw-left {
    width: 240px;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .ucw-left .ucw-head {
    text-align: center;
    padding-top: 30px;
    background: #ffffff;
  }

  .ucw-head .ucw-head-img {
    border-radius: 50px;
    overflow: hidden;
  }

  .ucw-head .ucw-user-name {
    height: 21px;
    overflow: hidden;
    line-height: 21px;
    color: #7F8293;
    font-size: 18px;
    padding-bottom: 23px;
    padding-top: 27px;
  }

  .user-center-warp .ucw-left a.blk {
    height: 40px;
    line-height: 40px;
    color: #7F8293;
    font-size: 16px;
    border-bottom: 1px solid rgba(216, 216, 216, 0.37);
    text-indent: 33px;
    transition: all .3s ease;
    border-left: 2px solid #fff;
    background: #ffffff;
  }

  .ucw-left a.blk.active, .ucw-left a.blk:hover {
    background-color: rgba(163, 163, 163, 0.05);
    color: #00BCA1;
    border-left: 2px solid #00BCA1;
  }

  /*end left*/
  /*right*/
  .user-center-warp .ucw-right {
    width: 880px;
    border-radius: 4px;
    background-color: #fff;
    overflow: hidden;
    margin-left: 30px;
    padding: 20px 30px;
  }

  /*账号安全 start*/
  .ucw-right .bind-btn {
    width: 120px;
  }

  .ucw-right .ucw-sub-titel {
    padding-left: 10px;
    height: 19px;
    line-height: 19px;
    color: #7F8293;
    border-left: 2px solid #00BCA1;
    font-size: 16px;
  }

  .ucw-right .no-bind-txt {
    padding-bottom: 83px;
    text-indent: 10px;
    height: 19px;
    line-height: 19px;
    color: #AEB9CC;
    font-size: 16px;
  }

  /*账号安全 right*/
  /*我的资料 start*/
  .ucw-right .sub-head {
    display: flex;
    margin-top: 30px;
    margin-bottom: 26px;
  }

  .ucw-right .ucw-head-img2-warp {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    background: #F9F8F8;
    overflow: hidden;
  }

  .ucw-right .ucw-head-img2 {
    margin: 20px auto;
    display: block;
  }

  /*end 我的资料*/

  .list-enter{
    opacity: 0;
    transform: translateX(100%);
  }
  .list-leave-to{
    opacity: 0;
    transform: translateX(-100%);
    position: absolute;
  }
  .list-enter-active,.list-leave-active{
    transition: all 0.5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/view/userInfo/UserInfoCenter.vue